import React from 'react'

import { useHistory, useLocation, useParams } from 'react-router-dom'

import { routes } from 'routes'
import { Container, ContentHeader } from 'components'
import * as service from 'service'
import ProfilesForm from './components/ProfilesForm'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

const ProfilesEdit = () => {
  const { profileId } = useParams()
  const history = useHistory()
  const location = useLocation()
  const snackbar = useSnackbar()
  const [isLoading, setIsLoading] = React.useState(false)

  const { response: responseProfile, isLoading: isLoadingProfile } = useFetch(
    service.recurrence.profiles.get,
    { profileId },
  )

  const {
    response: responseProfileFunctionalities,
    isLoading: isLoadingProfileFunctionalities,
  } = useFetch(service.recurrence.profileFunctionalities.get, { profileId })

  const data = React.useMemo(() => {
    if (!responseProfile || !responseProfileFunctionalities) {
      return
    }

    return {
      ...responseProfile.data.profile,
      functionalities: (
        responseProfileFunctionalities.data.profilePermissions || []
      ).reduce(
        (profileFunctionalities, functionality) => ({
          ...profileFunctionalities,
          [functionality.tag]: functionality.active,
        }),
        {},
      ),
    }
  }, [responseProfile, responseProfileFunctionalities])

  const disabled = React.useMemo(
    () => location.state && location.state.disableForm,
    [location],
  )

  const handleSubmit = async data => {
    const { functionalities, ...profile } = data
    setIsLoading(true)

    try {
      const responseProfile = await service.recurrence.profiles.update({
        profileId,
        name: profile.name,
        description: profile.description,
      })

      await Promise.all([
        ...Object.keys(functionalities).map(functionalityTag =>
          service.recurrence.profileFunctionalities.create({
            profileId: responseProfile.data.profile.id,
            functionalityTag,
            active: functionalities[functionalityTag],
          }),
        ),
      ])

      snackbar.open({
        message: 'Perfil alterado com sucesso!',
        variant: 'success',
      })

      history.push(routes.settings.all)
    } catch (error) {
      snackbar.open({
        message: 'Falha ao alterar perfil!',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Container>
      <ContentHeader title="Perfil" subtitle="Novo" />

      {!isLoadingProfile && !isLoadingProfileFunctionalities && (
        <ProfilesForm
          btnSubmitText="Salvar"
          disabled={disabled}
          data={data}
          isLoading={isLoading}
          onSubmit={handleSubmit}
        />
      )}
    </Container>
  )
}

export default ProfilesEdit
